export class GA4BaseEvent {
  fire(eventName: string, payload: any = {}) {
    if (window) {
      console.log('firing ' + eventName, payload);
      window.gtag('event', eventName, payload)
    }
  }
}